import { axiosInstance } from './axiosInstance';
import { getApiUrl } from './helpers';
import { ApiRoutes, MetadataApiResponse } from 'types';

export async function fetchMetadata() {
  const { data } = await axiosInstance.get<MetadataApiResponse>(getApiUrl({ path: ApiRoutes.Metadata }));
  return data;
}
